module.exports = __webpack_public_path__ + "img/20250818_2.2408507e.png";